import { style, globalStyle } from '@vanilla-extract/css'
import { vars } from '../design/theme.css'

// The one calm day strip that replaces Live's old stack of sticky bands (brief §7.3/§7.4):
// the sparkline + window picker, the almanac, and the running tally read as a single composed
// instrument panel beneath the collage — static, not sticky, not cards.
export const dayStrip = style({
  marginTop: vars.space[5],
  paddingTop: vars.space[4],
  borderTop: `1px solid ${vars.color.rule}`,
  display: 'flex',
  flexDirection: 'column',
  gap: vars.space[3],
})

// The empty state — a branded Cuckoo moment (brief §7.2): the station's own bird, then the
// honest line (listening vs offline vs no-data stay distinct, set by the caller's text).
export const empty = style({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: vars.space[4],
  padding: `${vars.space[8]} ${vars.space[4]}`,
  textAlign: 'center',
})
export const emptyMark = style({ width: '96px', height: 'auto', opacity: 0.7 })
globalStyle(`:root[data-theme="dark"] ${emptyMark}`, { filter: 'invert(1)' })
// The words themselves are the shared StateLine (design system) so a quiet Live reads in the
// same voice as an empty Stats period or a Journal with no completed day; only the padding is
// dropped here, because the mark above already gives the block its air.
export const emptyText = style({ padding: 0, fontStyle: 'italic' })
